// extracted by mini-css-extract-plugin
export default {"container":"yq-z","heading":"zq-z","text":"Aq-z","info":"Bq-z","link":"Cq-z","fullMaxWidth":"Dq-z"};